import dealerLocator from './DealerLocator/index.js';

const apps = {
	dealerLocator,
};

document.querySelectorAll('[data-vue-app]').forEach((el) => {
	const appName = el.dataset.vueApp;
	const mountFn = apps[appName];

	if (mountFn) {
		mountFn(el);
	} else {
		console.warn(`Vue app "${appName}" не найден`);
	}
});